import React, { useEffect } from 'react'
import styled from 'styled-components'
import Section01 from './section01/index'
import Section02 from './section02/index'
import Section03 from './section03/index'
import Section05 from './section05/index'
import FooterInLogo from '@components/NewMain/Footer'
import MobilePage from '../NewMobilePage/index'
import WebHeader from '@components/layout/WebHeader'
import { Desktop } from '@constants/mediaQuery'
import { useMediaQuery } from 'react-responsive'
import LandingPopup from '@components/simulated-trading/LandingPopup'
import useSearchParams from '@hooks/useSearchParams'
import { Helmet } from 'react-helmet-async'

const NewMainPage = () => {
  const isMobileSize = useMediaQuery({ query: `(max-width: ${Desktop}px)` })
  const { getParam } = useSearchParams()
  const source = getParam('source')
  useEffect(() => {
    if (source) {
      localStorage.setItem('source', source)
    }
  }, [source])
  return (
    <>
      <Helmet>
        <meta
          name='viewport'
          content='width=device-width, initial-scale=1, user-scalable=no, viewport-fit=cover'
        />
        <meta
          name='description'
          content='참가비 무료, 신청만 하면 바로 게임 시작! 최대 35만원의 주인공이 되어보세요.'
        />
        <meta property='og:type' content='website' />
        <meta
          property='og:title'
          content='일육공 160 - 공모주 투자의 확률을 높이다'
        />
        <meta
          property='og:description'
          content='참가비 무료, 신청만 하면 바로 게임 시작! 최대 35만원의 주인공이 되어보세요.'
        />

        <meta
          property='og:image'
          content='https://160ipo.com/share-image.png'
        />
        <meta property='og:image:width' content='800' />
        <meta property='og:image:height' content='400' />
        <title>일육공 160 - 공모주 투자의 확률을 높이다</title>
      </Helmet>
      <Container>
        <LandingPopup />
        {isMobileSize ? (
          <>
            <MobilePage />
          </>
        ) : (
          <>
            <WebHeader />
            <Section01 />
            <Section02 />
            <Section03 />
            <Section05 />
            <FooterInLogo />
          </>
        )}
      </Container>
    </>
  )
}

const Container = styled.div`
  scroll-behavior: auto;
  width: 100%;
`

export default NewMainPage
